/* eslint-env node */ // also required by the webpack config
const SUBSCRIPTION_TRIAL_DAYS = 30
const SUBSCRIPTION_PRICE = '$5/month'
const SUBSCRIPTION_PRICE_A_MONTH = SUBSCRIPTION_PRICE.replace('/month', ' a month')
const SUBSCRIPTION_TRIAL_OFFER = `${SUBSCRIPTION_TRIAL_DAYS}-day free trial with no card, then ${SUBSCRIPTION_PRICE} when you subscribe`
const MARKETING_META_TITLE = 'General Task - Tasks are cheap. Time is not.'
const MARKETING_META_DESCRIPTION = `General Task connects tasks, goals, and Google Calendar. Start with a ${SUBSCRIPTION_TRIAL_OFFER}.`
const MARKETING_SOCIAL_DESCRIPTION = `Connect tasks, goals, and Google Calendar with a ${SUBSCRIPTION_TRIAL_OFFER}.`

module.exports = {
    MARKETING_META_DESCRIPTION,
    MARKETING_META_TITLE,
    MARKETING_SOCIAL_DESCRIPTION,
    SUBSCRIPTION_PRICE,
    SUBSCRIPTION_PRICE_A_MONTH,
    SUBSCRIPTION_TRIAL_DAYS,
    SUBSCRIPTION_TRIAL_OFFER,
}
